import { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from '../../../layouts/dashboard';

const PageMading = lazy(() => import('./views/mading'));

const Mading = () => {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<PageMading />} />
      </Routes>
    </Layout>
  );
};

export default Mading;
